/**
 * @file SPメニューボタンのトグル動作
 *
 */
'use strict';

/**
 * @classname ShowSPMenuView
 * @classdesc ヘッダーの背景クラスつけ外し
 */
export default class ShowSPMenuView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ShowSPMenuView.constructor');
		this._$e = $e;
		this._$gnavsp = $('.gnav__sp');
		this._$gnavspbar = $('.header__gnav--sp-btn .bar');
		this._$body = $('body');
		this._$e.on('click', () => this.onClick());
	}

	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof ShowSPMenuView
	 * @return {undefined}
	 */
	onClick() {
		console.log('ShowSPMenuView.onClick');
		this._$body.toggleClass('stop-scroll');
		this._$gnavsp.toggleClass('is-show');
		this._$gnavspbar.toggleClass('was-show');
	}
}
